import { graphql } from 'react-relay';

export default graphql`
  query AccountPage_Query {
    viewer {
      id
      ...AccountPage_viewer
    }
  }
`;
